import { render, staticRenderFns } from "./GettingStartView.vue?vue&type=template&id=11c6d6d3&scoped=true&"
import script from "./GettingStartView.vue?vue&type=script&lang=js&"
export * from "./GettingStartView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all.css?vue&type=style&index=0&id=11c6d6d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c6d6d3",
  null
  
)

export default component.exports